<script lang="ts">
    import type {SearchResult} from "../NvbsSearchEngineApi/interfaces";
    import {LayoutType} from "./types";
    import {fly} from "svelte/transition";

    let {
        onclick,
        postdata,
        layout = LayoutType.Grid,
        category
    }: {
        onclick: (result: SearchResult) => void;
        postdata: SearchResult;
        layout: LayoutType;
        category: string;
    } = $props();

    let mouse_over = $state(false);
    let popup = $state<HTMLDivElement>();
    let x = $state(0);
    let y = $state(0);

    function pointer_move(event: PointerEvent) {
        if (layout === LayoutType.Dambord && mouse_over && popup) {
            // check for overflow
            const rect = popup.getBoundingClientRect();
            if (event.clientX + rect.width / 2 + 20 < window.innerWidth && event.clientX - rect.width / 2 > 0) {
                x = event.offsetX - rect.width / 2;
            }

            y = event.offsetY - 10;
        }
    }
</script>

{#if layout === LayoutType.List || layout === LayoutType.Grid}
    <button class="nvbs-search-result-post"
            onclick={() => onclick(postdata)}
            id="searchresult-{postdata.id}"
    >
        {#if postdata.thumbnail}
            <img src={postdata.thumbnail.webp} alt="" loading="lazy">
        {/if}
        <div class="info">
            <p class="info__title">{postdata.title}</p>
            {#if postdata.description}
                <p class="info__description">
                    {postdata.description}
                </p>
            {/if}
            {#if postdata.tags}
                <p class="info__tags">
                    {postdata.tags}
                </p>
            {/if}
            {#if postdata.categoryName}
                <p class="info__category_name">
                    {postdata.categoryName}
                </p>
            {/if}
        </div>
    </button>
{:else if layout === LayoutType.Dambord}
    <button class="nvbs-search-result-post-grid"
            onpointerover={() => mouse_over = true}
            onpointerout={() => mouse_over = false}
            onpointermove={pointer_move}
            onclick={() => onclick(postdata)}
    >
        {#if mouse_over}
            <div class="info-popup"
                 bind:this={popup}
                 transition:fly={{y: -50,duration: 300}}
                 style:left={x + 'px'}
                 style:top={y + 'px'}
            >
                <p class="info__title">{postdata.title}</p>
                {#if postdata.description}
                    <p class="info__description">
                        {postdata.description}
                    </p>
                {/if}
                {#if postdata.tags}
                    <p class="info__tags">
                        {postdata.tags}
                    </p>
                {/if}
                {#if postdata.categoryName}
                    <p class="info__category_name">
                        {postdata.categoryName}
                    </p>
                {/if}
            </div>
        {/if}
        {#if postdata.thumbnail}
            <img src={postdata.thumbnail.webp} alt="" loading="lazy">
        {/if}
    </button>

{/if}


<style lang="scss">
  .nvbs-search-result-post {
    display: flex;
    gap: 10px;
    border-top: 1px solid #eee;
    border-bottom: none;
    border-left: none;
    border-right: none;
    padding: 10px;
    transition: 0.2s all;
    cursor: pointer;
    background: none;

    img {
      width: var(--image-size);
      max-height: var(--image-size);
      object-fit: contain;
    }

    .info {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align: left;
      gap: 5px;

      p {
        margin: 0;
        line-height: 1.2;
      }

      .info__title {
        margin: 0;
        color: #375698;
        font-size: 17px;
      }

      .info__description {
        font-size: 14px;
      }

      .info__tags {
        font-size: 12px;
        color: #666;
      }

      .info__category_name {
        font-size: 12px;
        color: #d0021b;
      }
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);

      .info {
        .info__title {
          text-decoration: underline;
        }
      }
    }
  }


  .nvbs-search-result-post-grid {
    border: none;
    background: none;
    display: flex;
    gap: 10px;
    transition: 0.2s all;
    cursor: pointer;
    position: relative;
    padding: 0;

    img {
      width: var(--image-size);
      aspect-ratio: 1/1;
      object-fit: contain;
    }

    .info-popup {
      pointer-events: none;
      position: absolute;
      background-color: #fff;
      padding: 10px;
      border-radius: 5px;
      z-index: 10;
      display: flex;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      width: 300px;
      max-width: 90vw;
      flex-direction: column;
      transform: translateY(-100%);
    }
  }

  img {
    pointer-events: none;
  }
</style>
